import { FC } from "react";
import { EditBlock } from "../../components/EditBlock";
import { EditTravelWrapper, TitleWrapper, UpperBlock, UserID } from "./styles";

export const EditTravel: FC = () => {
  return (
    <EditTravelWrapper>
      <UpperBlock>
        <TitleWrapper>
          Поездки - <UserID>#3462</UserID>
        </TitleWrapper>
      </UpperBlock>
      <EditBlock />
    </EditTravelWrapper>
  );
};
